"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRWTokenFromAccessRules = (resource) => {
    if (!resource.accessRules) {
        return undefined;
    }
    const readWriteTokenRules = resource.accessRules.filter(r => r.type === "readWriteToken");
    if (readWriteTokenRules.length > 0) {
        // There's no reason to have more than one readWriteToken rules (so in fact multiple read write tokens).
        // But even if that happens, it's enough to get any of them to have access to the resource.
        return readWriteTokenRules[0].readWriteToken;
    }
    return undefined;
};
//# sourceMappingURL=common-helpers.js.map